<template>
  <a-card class="card-area">


    <div class="page-form-advanced-search">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="5">
           <a-form-item label="职位名称">
              <a-input v-model="queryParams.jobName" placeholder="职位名称" />
            </a-form-item>
          </a-col>
        </a-row>
				<a-row>
				  <a-col :span="12"> </a-col>
				  <a-col :span="12" :style="{ textAlign: 'right' }">
				    <a-button type="primary" @click="search">查询</a-button>
				    <a-button style="margin-left: 8px" @click="reset">重置</a-button>
				  </a-col>
				</a-row>
      </a-form>
    </div>
    
    
    <div class="operator">
      <a-button type="primary" @click="addRecruit" ghost>新增</a-button>
      <a-button @click="batchDelete">删除</a-button>
    </div>
    <a-table 
      ref="TableInfo" 
      :pagination="pagination" 
      @change="handleTableChange" 
      bordered 
      :loading="loading" 
      :columns="columns" 
      :data-source="dataSource" 
      :rowKey="(record) => record.id"
      :row-selection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
    >
      <a-tag slot="job-type" slot-scope="text">{{ text=='1'?"SR":(text=='2'?"Hourly":(text=='3'?"Intern":"未知")) }}</a-tag>
      <a-tag :color="text=='1'?'#1e90ff':'#aaa69d'" slot="isWorry" slot-scope="text">{{ text=='1'?"是":"否" }}</a-tag>
      <a-tag :color="text=='1'?'#87d068':'red'" slot="status" slot-scope="text">{{ text=='1'?"开启":"关闭" }}</a-tag>
      <div slot="labels" slot-scope="text">
        <div v-if="text">
          <a-tag v-for="(item, index) in text.split(',')" :key="index">{{ item }}</a-tag>
        </div>
      </div>
      <template slot="operation" slot-scope="text, record">
        <a-icon type="edit" theme="twoTone" twoToneColor="#4a9ff5" @click="editRecruit(record)" title="修改"></a-icon>
        &nbsp;
        <a-icon type="eye" theme="twoTone" twoToneColor="#42b983" @click="view(record)" title="详情"></a-icon>
      </template>
    </a-table>
    <job-add ref="recruitAdd" @close="handleRecruitAddClose" @success="handleRecruitAddSuccess" :recruitAddVisiable="recruitAddVisiable"></job-add>
    <job-edit ref="recruitEdit" @close="handleRecruitEditClose" @success="handleRecruitEditSuccess" :recruitEditVisiable="recruitEditVisiable"></job-edit>
    <job-info ref="recruitInfo" :infoVisiable="infoVisiable" :jobData="jobData" @_close="handleInfoClose"></job-info>
  </a-card>
</template>

<script>
import JobAdd from "./JobAdd";
import JobEdit from "./JobEdit";
import JobInfo from "./JobInfo";

const columns = [
  // {
  //   title: "序号",
  //   dataIndex: "key",
  //   width: 100
  // },
  {
    title: "职位名称",
    dataIndex: "jobName",
    width: 300
    // ellipsis: true
  },
  // {
  //   title: "职位亮点",
  //   dataIndex: "highlights",
  //   ellipsis: true
  // },
  // {
  //   title: "工作简介",
  //   dataIndex: "jobDescription",
  //   ellipsis: true
  // },
  // {
  //   title: "岗位要求",
  //   dataIndex: "requirements",
  //   ellipsis: true
  // },
  // {
  //   title: "职位标签",
  //   dataIndex: "labels",
  //   scopedSlots: { customRender: 'labels' },
  //   ellipsis: true
  // },
  {
    title: "部门",
    dataIndex: "deptName",
    // width: 200
    // ellipsis: true
  },
  // {
  //   title: "工作年限",
  //   dataIndex: "experience",
  //   ellipsis: true
  // },
  // {
  //   title: "学历",
  //   dataIndex: "degree",
  //   ellipsis: true
  // },
  {
    title: "招聘人数（人）",
    dataIndex: "headCount",
    width: 150
    // ellipsis: true
  },
  {
    title: "职位类别",
    dataIndex: "jobType",
    scopedSlots: { customRender: 'job-type' },
    width: 150
    // ellipsis: true
  },
  {
    title: "急招",
    dataIndex: "isWorry",
    scopedSlots: { customRender: 'isWorry' },
    width: 150
    // ellipsis: true
  },
  {
    title: "职位状态",
    dataIndex: "status",
    scopedSlots: { customRender: 'status' },
    width: 150
    // ellipsis: true
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: 'operation' },
    fixed: "right",
  }
];

export default {
  components: {
    JobAdd,
    JobEdit,
    JobInfo
  },
  data() {
    return {
      dataSource: [],
      selectedRowKeys: [],
      paginationInfo: null,
      queryParams: {
        jobName: undefined
      },
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      columns,
      // rowSelection,
      loading: false,
      recruitAddVisiable: false,
      recruitEditVisiable: false,
      infoVisiable: false,
      jobData: {}
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    view(record) {
      console.log("显示意见信箱 => ", record);
      this.jobData = record;
      this.infoVisiable = true;
    },
    handleInfoClose() {
      this.infoVisiable = false;
    },
    onSelectChange (selectedRowKeys) {
      // console.log("selectedRowKeys==>", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    },
    handleTableChange (pagination, filters, sorter) {
      this.paginationInfo = pagination
      this.fetch({
        ...this.queryParams
      })
    },
    search () {
      this.fetch({
        ...this.queryParams
      })
    },
    fetch(params = {}) {
      this.loading = true;
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get("recruit", {...params}).then((r) => {
        // console.log("招聘岗位", r.data);
        let rows = r.data.rows || [];
        const pagination = { ...this.pagination };
        pagination.total = r.data.total;
        // if(rows) {
        //   for (const key in rows) {
        //     rows[key]['key'] = +key + 1;
        //   }
        // }
        this.dataSource = rows;
        this.pagination = pagination;
        this.loading = false;
      });
    },
    editRecruit(record) {
      this.recruitEditVisiable = true;
      this.$refs.recruitEdit.setFormFields(record);
    },
    handleRecruitEditClose() {
      this.recruitEditVisiable = false;
    },
    handleRecruitEditSuccess() {
      this.recruitEditVisiable = false;
      this.$message.success("修改招聘岗位成功！");
      this.fetch();
    },
    addRecruit() {
      this.recruitAddVisiable = true;
    },
    handleRecruitAddClose() {
      this.recruitAddVisiable = false;
    },
    handleRecruitAddSuccess() {
      this.recruitAddVisiable = false;
      this.$message.success("添加招聘岗位成功！");
      this.fetch();
    },
    batchDelete() {
      if(!this.selectedRowKeys.length) {
        this.$message.warning("请选择需要删除的记录");
      } else {
        let that = this;
        that.$confirm({
          title: "确定删除所选中的记录？",
          content: "当您点击确定按钮后，这些记录将会被彻底删除",
          centered: true,
          onOk () {
            let ids = that.selectedRowKeys.join();
            that.$delete(`recruit/${ids}`)
              .then(() => {
                that.$message.success("删除成功！");
                that.selectedRowKeys = [];
                that.fetch();
              })
              .catch(e => console.log("岗位删除失败！==> ", e));
          },
          onCancel () {
            that.selectedRowKeys = [];
          }
        })
      }
    },
		reset() {
		  // 取消选中
		  this.selectedRowKeys = [];
		  // 重置分页
		  this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent;
		  if (this.paginationInfo) {
		    this.paginationInfo.current = this.pagination.defaultCurrent;
		    this.paginationInfo.pageSize = this.pagination.defaultPageSize;
		  }
		  // 重置列过滤器规则
		  this.filteredInfo = null;
		  // 重置列排序规则
		  this.sortedInfo = null;
		  // 重置查询参数
		  this.queryParams = {
		    jobName: undefined
		  },
		  this.fetch();
		},
  }
}
</script>

<style lang="less" scoped>
@import "../../../utils/Common.less";
</style>